import gql from 'graphql-tag';

export const editorBlockViewBaseFragment = gql`
  fragment editorBlockViewFragmentBase on EditorBlock {
    id
    contentId
    content {
      id
      displayName
      sections {
        id
        displayName
        hidden
        branding {
          backgroundColor
          h1Color
          h2Color
          textColor
          supplementaryColor
          pricingTable {
            headerBackgroundColor
            headerTextColor
          }
          inputField {
            backgroundColor
            textColor
          }
        }
        rows {
          id
          type
          columnCount
          cells {
            id
            width
            type
            nodes {
              id
              type
              content
              imageId
              linkUrl
              dimensions {
                width
                height
              }
              displayName
              markdownFieldId
              mergeTagsSettings {
                fullName
                title
                companyName
                companyNumber
                email
                signDate {
                  show
                  format
                }
              }
              contractId
              contractDisplaySettings {
                name
                description
                title
                company
                email
              }
              recipientMaps {
                participantId
                contractRecipientId
              }
              borderStyle
              fields {
                id
                type
                category
                mergeKey
                recipientId
                userId
                customName
                value
                markdownFormattingOptions
                participantId
                inputSettings {
                  type
                  required
                  label
                  richTextLabel
                  helpText
                  connectedId
                  width
                  minValue
                  maxValue
                  placeholder
                  options
                  hide
                  minChars
                  maxChars
                  regex {
                    enabled
                    pattern
                    description
                  }
                }
              }
              inputFieldSets {
                ids
              }
              caption
              heading
              imageSize
              imageAlign
              align
              url
              videoId
              imageTransforms {
                translateX
                translateY
                scale
              }
              dividerType
              dividerPadding
              tableStyle {
                borderColor
                headerRowBackgroundColor
                alternateRowColor
              }
              name
              preCalculated
              locked
              pricingTableSections {
                id
                displayName
                displayMode {
                  imageDisplayMode
                }
                columns {
                  id
                  name
                  displayName
                  width
                  enabled
                  isCustom
                  type
                  unit
                  productPropertyId
                }
                rows {
                  id
                  values {
                    columnId
                    value
                    images {
                      imageId
                      transforms {
                        scale
                        translateX
                        translateY
                      }
                    }
                  }
                  discountFlatFee
                  taxFlatFee
                  optionalProductFieldId
                  variableQuantityFieldId
                }
                sectionSummary {
                  discount {
                    value
                    enabled
                    flatFee
                    displayName
                  }
                  tax {
                    value
                    enabled
                    flatFee
                    displayName
                  }
                  price {
                    value
                    enabled
                    flatFee
                    displayName
                  }
                  extendedSummaries {
                    columnId
                    displayName
                    enabled
                    name
                    unit
                    value
                  }
                }
              }
              pricingTableSummaryValues {
                displayName
                discount {
                  value
                  enabled
                  flatFee
                  displayName
                }
                tax {
                  value
                  enabled
                  flatFee
                  displayName
                }
                price {
                  value
                  enabled
                  flatFee
                  displayName
                }
                baseSubtotal {
                  enabled
                  value
                  displayName
                }
                taxBreakdown {
                  enabled
                  value
                  displayName
                  rates {
                    enabled
                    value
                    displayName
                    rate
                  }
                }
                combinedSubtotal {
                  enabled
                  value
                  displayName
                }
              }
              currencySettings {
                formatOptions {
                  currency
                  currencyDisplay
                }
                locale
              }
              pricingSummarySettings {
                displayPricingGroups
                hideTotalPrice
                includeZeroValueTables
              }
              labels {
                nameColumn
                priceColumn
                totalPrice
              }
              tables {
                id
                include
                displayName
              }
            }
          }
        }
      }
    }
  }
`;

export const editorBlockViewFragment = gql`
  fragment editorBlockViewFragment on EditorBlock {
    ...editorBlockViewFragmentBase
    contentVersion
  }
  ${editorBlockViewBaseFragment}
`;

export const dealroomEditorBlockViewFragment = gql`
  fragment dealroomEditorBlockViewFragment on EditorBlock {
    ...editorBlockViewFragmentBase
  }
  ${editorBlockViewBaseFragment}
`;
